import { PortableText } from "@portabletext/react";
import React from "react";
import { Button } from "./btn";
import { builder } from "../../utils/sanityImageUrl";

const ContentSection = ({ data }) => {
  const titleColor = data?.titleColor ? `${data?.titleColor}` : "#ffffff";
  const descriptionColor = data?.descriptionColor
    ? `${data?.descriptionColor}`
    : "#fff";

  return (
    <div className="max-w-[1100px] mx-auto xl:max-w-[1280px] 2xl:max-w-[1400px] 3xl:max-w-[1655px] px-5 sm:px-10">
      <div className="w-full flex-1 h-full">
        <div className="w-full">
          <h1
            className="block font-georgia font-bold text-4xl md:text-[50px] md:leading-[55px] tracking-[1.1px] mb-[21px]"
            style={{ color: `${titleColor}` }}
          >
            {data.title}
          </h1>
          {data._rawDescription && (
            <div
              className="text-lg leading-[25px] pb-5 md:pb-10 whitespace-pre-wrap"
              style={{
                color: descriptionColor,
              }}
            >
              <PortableText
                value={data._rawDescription}
                components={{
                  types: {
                    btn: ({ value }) => {
                      return (
                        <div className="relative overflow-visible group my-6 w-fit">
                          <Button btn={value} />
                        </div>
                      );
                    },
                    image: ({ value }) => {
                      return (
                        <div className="relative overflow-visible group my-6 w-fit">
                          <div className="w-full max-w-[1000px] my-4">
                            <img
                              src={builder.image(value?.asset._ref)}
                              alt={value?.alt}
                              className="w-full"
                              style={{
                                maxWidth: value.width
                                  ? `${value.width}px`
                                  : "100%",
                                maxHeight: value.height
                                  ? `${value.height}px`
                                  : "100%",
                              }}
                            />
                          </div>
                        </div>
                      );
                    },
                  },
                }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContentSection;
